import React, { useState } from 'react'
import {
  Modal,
  Card,
  Col,
  Row,
  Collapse,
  Tabs,
  message,
  Dropdown,
  Menu,
  Avatar,
  List,
  Spin,
  Button
} from 'antd'
import ds from '../../Services/DataServices'
import { useHistory } from 'react-router-dom'
import { useStore, useDispatch, useSelector } from 'react-redux'
import IntlMessages from '../../util/IntlMessages'
import { loadSellSelectedAttributes } from '../../appRedux/actions/Sell'
import {
  closeAttribModal,
  closeAttribTabsModal,
  formatDigits,
  getDecryptID,
  getRandomInt,
  isEmptyObject,
  loadDropDownStates,
  loadShowAttribDrop,
  notAllowMsgCheck
} from '../../appRedux/actions'
import { loadIsShowSellAttribute } from '../../appRedux/actions'
import {
  CaretRightOutlined,
  EuroOutlined,
  HistoryOutlined,
  ShoppingCartOutlined,
  WalletOutlined
} from '@ant-design/icons'
import ParkRetrieveListItem from './ParkRetrieveListItem'
import moment from 'moment'
import { BEHAVIOUR_TYPE } from '../../Services/DataServices'
import Placeholder from '../../assets/images/placeholder.svg'
import { GetIndexDBDataByTableName } from '../../appRedux/actions/IndexDBActions'
import { INDEX_DB_NAME, INDEX_DB_TABLES } from '../../constants/IndexDBData'

const { Panel } = Collapse
const confirm = Modal.confirm

const SellAttribCard = props => {
  const { d, selectedID, id, hours, minutes, currency, keyy } = props
  const selOut = props.out ? props.out : false
  const selReg = props.reg ? props.reg : false
  const dispatch = useDispatch()
  const history = useHistory()
  const { TabPane } = Tabs

  const getReduxShowRegSel = useSelector(
    ({ commonConfigs }) => commonConfigs.getIsSelectReg
  )
  const getReduxStoreOutlets = useSelector(
    ({ Sell }) => Sell.openCloseStoreOutlets
  )
  const getReduxSelectedStoreOutlets = useSelector(
    ({ Sell }) => Sell.openCloseSelectedStoreOutlets
  )
  const showSellAttribute = useSelector(({ Sell }) => Sell.showSellAttribute)
  const sellAttributeLoading = useSelector(
    ({ Sell }) => Sell.sellAttributeLoading
  )
  const sellAttributes = useSelector(({ Sell }) => Sell.sellAttributes)
  const sellAttributesGroups = useSelector(
    ({ Sell }) => Sell.sellAttributesGroups
  )
  const sellSelAttributes = useSelector(({ Sell }) => Sell.sellSelAttributes)
  const getCurrentSalesOrderData = useSelector(
    ({ Sell }) => Sell.currentSalesOrderData
  )
  const showAttribDrop = useSelector(
    ({ commonConfigs }) => commonConfigs.showAttribDrop
  )
  const dropDownStates = useSelector(
    ({ commonConfigs }) => commonConfigs.dropDownStates
  )

  const [getIsSpinning, setIsSpinning] = useState(true)
  const [saleData, setSaleData] = useState({})
  const [activeKey, setActiveKey] = useState('')
  // const [dropdownStates, setDropdownStates] = useState([])

  // React.useEffect(() => {
  //   let mounted = true
  //   if (mounted) {
  //     closeDropDown()
  //   }
  //   return () => (mounted = false)
  // }, [showAttribDrop])

  function onAttribClick (e) {
    const currSale =
      getCurrentSalesOrderData &&
      !isEmptyObject(getCurrentSalesOrderData) &&
      getCurrentSalesOrderData.E_SalesOrderID
    let showPop = e && e.inProgress
    if (currSale) {
      const exist =
        e && e.sales && e.sales.length > 0
          ? e.sales.filter(a => a.saleOrderID == getDecryptID(currSale))
          : []
      if (exist && exist.length > 0) showPop = false
    }
    if (showPop) {
      showConfirm(e)
    } else {
      onProceed(e)
    }
  }

  function onProceed (e) {
    const group = sellAttributesGroups.filter(
      a => getDecryptID(a.groupID) == getDecryptID(e.groupID)
    )
    if (group && group.length > 0) {
      const selGroup = group[0]
      const selAttrib =
        sellSelAttributes && sellSelAttributes.length > 0
          ? sellSelAttributes
          : []
      const body = {
        sellAttribID: getRandomInt(100000000),
        groupID: e.groupID ? e.groupID : '',
        attributeID: e.attributeID ? e.attributeID : '',
        groupName: selGroup.title ? selGroup.title : '',
        attributeName: e.title ? e.title : '',
        inProgress: e.inProgress ? e.inProgress : false
      }
      dispatch(loadSellSelectedAttributes(selAttrib.concat(body)))
    }
    // dispatch(loadIsShowSellAttribute(false))
    closeAttribModal(dispatch, dropDownStates)
    closeAttribTabsModal(dispatch, dropDownStates)
  }

  function showConfirm (e) {
    confirm({
      title: `${e.title ? e.title : 'This space'} is already in use.`,
      content: `Are you sure you want to continue?`,
      okText: 'Yes',
      cancelText: 'No',
      okButtonProps:{className: 'dk-btn-add close-reg-btn'},
      cancelButtonProps: {className: "dk-btn-cancel close-reg-btn"},
      onOk () {
        onProceed(e)
      },
      onCancel () {
        //console.log('Cancel');
      }
    })
  }

  const handleDropdownClick = e => {
    e.stopPropagation() // Prevent event propagation to the Modal
  }

  async function getDetailService (body) {
    const getSaleHistoryByID = ds.getSaleHistoryByIdService(
      body,
      BEHAVIOUR_TYPE.GET
    )
    await getSaleHistoryByID
      .then(res => {
        setIsSpinning(false)
        if (res && res.length > 0) {
          //marking to identify that the prods coming first time from backend
          const sale = res[0]
          if (sale.products && sale.products.length > 0) {
            sale.products.map(a => (a.firstTime = true))
          }
          setSaleData(sale)
        } else {
          setSaleData({})
        }
      })
      .catch(e => {
        setSaleData({})
        notAllowMsgCheck(e)
        setIsSpinning(false)
      })
  }

  function onPanelClick (e, id, key, isOffline) {
    if (e && e.length > 0 && (id || isOffline)) {
      setSaleData({})
      setActiveKey(key)
      setIsSpinning(true)
      let body = {
        OutletID: '',
        SalesOrderID: `${id}&&_9efa-1ea9-4faf-88ed-a48e65b46643`,
        SalesOrderStatusID: '',
        CustomerID: '',
        UserID: '',
        IsRetrieve: true
      }
      if (isOffline) fetchIndexedSale(isOffline)
      else getDetailService(body)
    } else {
      setSaleData({})
      setActiveKey('')
    }
  }

  function fetchIndexedSale (indexKey) {
    setIsSpinning(true)
    const data = GetIndexDBDataByTableName(INDEX_DB_NAME, INDEX_DB_TABLES.SALES)
    data
      .then(e => {
        setIsSpinning(false)
        if (e && e.length > 0 && indexKey) {
          let parkedSale = e.filter(q => q.indexKey == indexKey)
          if (parkedSale && parkedSale.length > 0) {
            parkedSale.map(q => {
              if (q.products && q.products.length > 0) {
                q.products.map(a => (a.firstTime = true))
              }
            })
            let sale = { ...parkedSale[0] }
            setSaleData(sale)
          } else {
            setSaleData({})
            setActiveKey('')
          }
        } else {
          setSaleData({})
          setActiveKey('')
        }
      })
      .catch(e => {
        setIsSpinning(false)
        setSaleData({})
        setActiveKey('')
        console.log(
          'INDEX_DB_ERROR -> fetchIndexedSale, attribute parked offline sale -->',
          e
        )
      })
  }

  const handleDropdownToggle = index => {
    const updatedStates = [...dropDownStates]
    updatedStates[index] = !updatedStates[index]
    updatedStates.map((q, w) => {
      if (w != index) {
        q = false
      }
    })
    dispatch(loadDropDownStates(updatedStates))
    // setDropdownStates(updatedStates)
  }

  // function closeDropDown () {
  //   const updatedStates = [...dropDownStates]
  //   updatedStates.map(a => (a = false))
  //   dispatch(loadDropDownStates(updatedStates))
  //   // setDropdownStates(updatedStates)
  // }

  return (
    d && (
      <Card
        hoverable
        style={{
          textAlign: 'Center',
          borderRadius: 8,
          display: 'grid',
          innerWidth: '100%',
          outerWidth: '100%',
          background: 'rgb(85 88 92)',
          minHeight: '118px'
        }}
        className={`${
          id == selectedID || d.inProgress
            ? 'ant-attribcard-bordered-active'
            : 'ant-regcard-bordered-deactive'
        } dk-attribute-card reservation-cards`}
        onClick={() => onAttribClick(d)}
        key={keyy}
      >
        <div>
          <h4 style={{ fontWeight: 600, color: 'white' }}>{d.title}</h4>
          {/* {d.inProgress && (
            <p
              style={{
                color: '#16ff01',
                borderBottom: '1px solid #fff',
                paddingBottom: '1px'
              }}
            >
              In Use
            </p>
          )} */}
          {d.inProgress ? (
            <div
              className='sell-attrib-footer'
              onClick={w => w.stopPropagation()}
            >
              <span className='txt-grp' style={{ fontSize: 16 }}>
                <HistoryOutlined
                  style={{
                    marginRight: 5,
                    display: 'inline-grid'
                  }}
                />
                {hours < 10 ? `0${hours}` : hours}:
                {minutes < 10 ? `0${minutes}` : minutes}
              </span>
              <span className='txt-grp' style={{ fontSize: 16 }}>
                {currency && currency.currencySymbol ? (
                  <span
                    style={{
                      marginRight: 5,
                      marginLeft: 16,
                      display: 'inline-grid'
                    }}
                  >
                    {currency.currencySymbol}
                  </span>
                ) : (
                  <WalletOutlined
                    style={{
                      marginRight: 5,
                      marginLeft: 16,
                      display: 'inline-grid'
                    }}
                  />
                )}
                {formatDigits(d.amount, 2)}
              </span>
              <br />
              <div className='book-btn' style={{ display: 'inline-flex' }}>

                <Dropdown
                  key={keyy}
                  onClick={handleDropdownClick}
                  trigger={['click']}
                  visible={dropDownStates[keyy]}
                  onVisibleChange={() => handleDropdownToggle(keyy)}
                  overlay={
                    <>
                      {d.sales &&
                        d.sales.length > 0 &&
                        d.sales.map((f, key) => {
                          let hourDiff = 0
                          let minDiff = 0
                          if (f && f.createdOn) {
                            const startTime = new Date(f.createdOn)
                            const endTime = new Date()
                            const timeDifference = endTime - startTime
                            hourDiff = Math.floor(
                              timeDifference / (1000 * 60 * 60)
                            )
                            minDiff = Math.floor(
                              (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
                            )
                          }
                          return (
                            <Collapse
                              activeKey={activeKey}
                              onChange={e =>
                                onPanelClick(e, f.saleOrderID, key, f.isOffline)
                              }
                            >
                              <Panel
                                key={key}
                                className='custom-promolist-help'
                                showArrow={false}
                                header={
                                  <div>
                                    <CaretRightOutlined
                                      style={{
                                        display: 'inline-flex',
                                        fontSize: 18,
                                        marginRight: 6
                                      }}
                                    />
                                    <span
                                      style={{ fontSize: 16, marginRight: 22 }}
                                    >
                                      Receipt:
                                      {f.receiptCode
                                        ? ` ${f.receiptCode}`
                                        : ` ${key + 1}`}
                                    </span>
                                    <span style={{ fontSize: 15 }}>
                                      <HistoryOutlined
                                        style={{
                                          marginRight: 5,
                                          display: 'inline-grid'
                                        }}
                                      />
                                      {hourDiff < 10
                                        ? `0${hourDiff}`
                                        : hourDiff}
                                      :{minDiff < 10 ? `0${minDiff}` : minDiff}
                                    </span>
                                    <span style={{ fontSize: 15 }}>
                                      {currency && currency.currencySymbol ? (
                                        <span
                                          style={{
                                            marginRight: 5,
                                            marginLeft: 22,
                                            display: 'inline-grid'
                                          }}
                                        >
                                          {currency.currencySymbol}
                                        </span>
                                      ) : (
                                        <WalletOutlined
                                          style={{
                                            marginRight: 5,
                                            marginLeft: 16,
                                            display: 'inline-grid'
                                          }}
                                        />
                                      )}
                                      {formatDigits(f.amount, 2)}
                                    </span>
                                    <span
                                      style={{ fontSize: 15, marginLeft: 18 }}
                                    >
                                      {moment(f.createdOn).format(
                                        'MMMM Do YYYY, h:mm:ss a'
                                      )}
                                    </span>
                                  </div>
                                }
                              >
                                <Spin
                                  tip={
                                    <IntlMessages id='sell.cashlisting.cashloading' />
                                  }
                                  spinning={getIsSpinning}
                                  size='large'
                                >
                                  {saleData && !isEmptyObject(saleData) ? (
                                    <ParkRetrieveListItem
                                      retrieveItem={saleData}
                                      type='attrib'
                                    />
                                  ) : (
                                    <List.Item className='custom-mg-right-10 ant-select-item custom-ant-select-item--option dk-parked-list-padding'>
                                      <List.Item.Meta
                                        style={{
                                          padding: 12,
                                          borderRadius: 12,
                                          background: '#e5e5e5'
                                        }}
                                        avatar={
                                          <Avatar
                                            src={Placeholder}
                                            className='dk-avatar-retrive-sale'
                                          />
                                        }
                                        // {retrieveItem.quantity}
                                        title={
                                          <div className='custom-inline'>
                                            <p className='custom-div-show ant-custom-mb-auto'>
                                              {'1'}
                                              {' × '}
                                              {'Name'}
                                            </p>
                                            <p className='custom-div-show ant-custom-mb-auto'>
                                              {'2'}
                                              {' × '}
                                              {'Name'}
                                            </p>
                                            <p className='custom-div-show ant-custom-mb-auto'>
                                              {'3'}
                                              {' × '}
                                              {'Name'}
                                            </p>
                                          </div>
                                        }
                                        description={
                                          <>
                                            <Row>
                                              <Col span={24}>
                                                <p>
                                                  <IntlMessages id='sell.sell.retrievesell.parkedabout' />{' '}
                                                  {'Date'}{' '}
                                                  <IntlMessages id='sell.sell.retrievesell.by' />{' '}
                                                  {`User System`}
                                                </p>
                                              </Col>
                                            </Row>
                                          </>
                                        }
                                      />
                                      <i className='icon icon-forward custom-icon-blue' />
                                    </List.Item>
                                  )}
                                </Spin>
                              </Panel>
                            </Collapse>
                          )
                        })}
                    </>
                  }
                >
                  <span>
                    <Button
                      style={{ marginBottom: 10, marginRight: 8 }}
                      size='small'
                      // className='modal-cross-btn'
                      shape='circle'
                      icon={<ShoppingCartOutlined />}
                    />
                    <span style={{ fontSize: 18, fontWeight: 500 }}>
                      {d.sales && d.sales.length > 0 ? d.sales.length : 1}
                    </span>
                  </span>
                  {/* <span
                    className='gx-link ant-dropdown-link gx-text-grey'
                    style={{ marginLeft: 6, fontSize: 18 }}
                  >
                    <i
                      style={{ color: '#ffffff' }}
                      className='icon icon-chevron-down'
                    />
                  </span> */}
                </Dropdown>
              </div>
            </div>
          ) : (
            <p style={{ display: 'none' }} className='custom-addpromo-hidetext'>
              a
            </p>
          )}
        </div>
      </Card>
    )
  )
}

export default SellAttribCard
